'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import PortalIdParser from 'PortalIdParser';
import UIAlert from 'UIComponents/alert/UIAlert';
import UILink from 'UIComponents/link/UILink';
const leadSyncSettingsUrl = `/settings/${PortalIdParser.get()}/marketing/ads/leadSyncing`;

const FormSettingsLink = props => /*#__PURE__*/_jsx(UILink, Object.assign({
  external: true,
  href: leadSyncSettingsUrl
}, props));

const LeadSyncMissingEmailBanner = ({
  onClose
}) => /*#__PURE__*/_jsx(UIAlert, {
  closeable: true,
  onClose: onClose,
  titleText: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "errors.permissions.headsUp"
  }),
  type: "danger",
  children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
    message: 'ADS_ACCOUNT_CONNECTION.leadSync.missingEmailSettings_jsx',
    elements: {
      FormSettingsLink
    }
  })
});

export default LeadSyncMissingEmailBanner;